import { z } from 'zod';

import { IEndpointSchema, makeEndpoint } from '../common';
import { TranslationSchema } from '../translation';

export const PatchVibesTranslationsRequestSchema = z.object({
  translations: z.array(TranslationSchema.omit({ createdAt: true, updatedAt: true, version: true })),
});

export const PatchVibesTranslationsEndpoint = makeEndpoint({
  method: 'PATCH',
  url: ({ brandId }: { brandId: string }) => `/v1/${brandId}/vibes/i18n`,
  requestSchema: PatchVibesTranslationsRequestSchema,
  responseSchema: z.void(),
});

export type IPatchVibesTranslationsEndpoint = IEndpointSchema<typeof PatchVibesTranslationsEndpoint>;
